/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@material-tailwind/react";
import { LoadingButton } from "@mui/lab";
import { Autocomplete, Box, Divider, Stack } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  RHFEditor,
  RHFSwitch,
  RHFTextField,
} from "../../../components/hook-form";
import FormProvider from "../../../components/hook-form/FormProvider";
import Iconify from "../../../components/iconify";
import { Upload } from "../../../components/upload";
import {
  createProduct,
  deleteProductImage,
  updateProduct,
} from "../../../redux/slices/productSlice";
import { appendFormValuesToFormData } from "../../../utils/appendFormData";

const Form = ({ handleClose, data, isEdit = false, refresh, setRefresh }) => {
  console.log(data, "dta");
  // TODO: hooks

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // TODO: useStates
  const [variants, setVairants] = useState([
    {
      size: "",
      brand: "",
      litre: "",
      price: "",
      selling_price: "",
      color: "",
      stock: 1,
    },
  ]);
  const [documents, setDocuments] = useState([]);
  const [galleries, setGalleries] = useState([]);
  const [filteredSubCategoryData, setFilteredSubCategoryData] = useState([]);

  // TODO: get the data from slice

  const createProductLoading = useSelector((state) => state.product.isLoading);
  const categories = useSelector((state) => state.category.categories);
  const mainCategories = useSelector((state) => state.category.mainCategories);

  const Schema = Yup.object().shape({
    name: Yup.string().required("product's name is required"),
    sku: Yup.string().required("product's sku is required"),
    category: Yup.string().required("Select main category"),
    sub_category: Yup.string().required("Select sub category"),
    description: Yup.string().required("product's description is required"),
  });

  // TODO: default values in the form
  const defaultValues = useMemo(
    () => ({
      name: data?.name || "",
      sku: data?.sku || "",
      category: data?.category?.parent?.id || "",
      sub_category: data?.category?.id || "",
      description: data?.description || "",
      status: data?.status || 0,
      is_featured: data?.is_featured || 0,
      is_new: data?.is_new || 0,
      is_trending: data?.is_trending || 0,
      is_weekly_deals: data?.is_weekly_deals || 0,
      stock: data?.stock || 0,
      price: data?.price || 0,
      selling_price: data?.selling_price || 0,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  const methods = useForm({
    resolver: yupResolver(Schema),
    defaultValues,
  });
  const { handleSubmit, reset, watch, setValue } = methods;
  const selectedMainCategory = watch("category");

  // TODO: useEffects, write the useEffect codes here

  useEffect(() => {
    setGalleries(data?.gallery?.map((g) => g?.url) || []);

    if (isEdit && data) {
      reset(defaultValues);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, data]);

  useEffect(() => {
    const newVariants = data?.variations?.map((variation) => ({
      id: variation?.id,
      size: variation?.size,
      price: variation?.price,
      selling_price: variation?.selling_price,
      color: variation?.color,
      brand: variation?.brand,
      litre: variation?.litre,
      stock: variation?.stock,
    }));

    if (newVariants?.length) {
      setVairants(newVariants);
    }
  }, [data?.variations]);

  useEffect(() => {
    if (selectedMainCategory) {
      const filteredSubCategories = categories?.data
        ?.filter((category) => category.parent?.id === selectedMainCategory)
        ?.map((category) => ({
          label: category?.name,
          value: category?.id,
        }));

      // setValue("sub_category", "");
      setFilteredSubCategoryData(filteredSubCategories);
    }
  }, [categories?.data, selectedMainCategory, setValue]);

  // ======

  // TODO: functions

  // TODO: handle upload galleries

  const handleDropGallery = useCallback((acceptedFiles) => {
    const newFile = acceptedFiles[0];
    if (newFile) {
      setDocuments((prev) => [
        ...prev,
        Object.assign(newFile, {
          preview: URL.createObjectURL(newFile),
          key: prev.length,
        }),
      ]);
    }
  }, []);

  // TODO: handle add and remove variants
  const handleAddFields = () => {
    setVairants((prev) => [
      ...prev,
      {
        price: variants[variants.length - 1].price,
        selling_price: variants[variants.length - 1].selling_price,
        size: variants[variants.length - 1].size,
        color: variants[variants.length - 1].color,
        litre: variants[variants.length - 1].litre,
        brand: variants[variants.length - 1].brand,
        stock: 1,
      },
    ]);
  };

  const handleRemoveFields = (index) => {
    setVairants((prev) => prev.filter((_, i) => i !== index));
  };

  const onCreateProduct = (values) => {
    // TODO: dispatch the action to create a product
    const formData = new FormData();

    appendFormValuesToFormData(formData, {
      is_trending: values.is_trending ? 1 : 0,
      is_weekly_deals: values.is_weekly_deals ? 1 : 0,
      is_new: values.is_new ? 1 : 0,
      is_featured: values.is_featured ? 1 : 0,
      category: values?.sub_category,
      name: values?.name,
      description: values?.description,
      sku: values?.sku,
      price: values?.price || 0,
      selling_price: values?.selling_price || 0,
      stock:
        variants?.reduce((acc, curr) => (acc += Number(curr?.stock)), 0) ||
        values?.stock,
    });

    if (documents.length) {
      documents.forEach((doc) => {
        formData.append("gallery", doc);
      });
    }

    dispatch(
      createProduct({
        data: formData,
        enqueueSnackbar,
        handleClose,
        params: {
          populate: "gallery,category.parent,variations",
        },
        variations: variants,
      })
    );
  };

  const onUpdateProduct = (values) => {
    // TODO: dispatch the action to update a product
    const formData = new FormData();

    appendFormValuesToFormData(formData, {
      is_trending: values.is_trending ? 1 : 0,
      is_weekly_deals: values.is_weekly_deals ? 1 : 0,
      is_new: values.is_new ? 1 : 0,
      is_featured: values.is_featured ? 1 : 0,
      category: values?.sub_category,
      name: values?.name,
      description: values?.description,
      sku: values?.sku,
      price: values?.price || 0,
      selling_price: values?.selling_price || 0,
      stock:
        variants?.reduce((acc, curr) => (acc += Number(curr?.stock)), 0) ||
        values?.stock,
    });

    if (documents.length) {
      documents.forEach((doc, index) => {
        formData.append(`gallery`, doc);
      });
    }

    dispatch(
      updateProduct({
        data: formData,
        enqueueSnackbar,
        handleClose,
        id: data?.id,
        setRefresh,
        params: {
          populate: "gallery,category.parent,variations",
        },
        variations: variants,
        variation_already_created: data?.variations?.length > 0,
      })
    );
  };

  // console.log

  return (
    <Box p={3}>
      <FormProvider
        methods={methods}
        onSubmit={handleSubmit(isEdit ? onUpdateProduct : onCreateProduct)}
      >
        <Box
          rowGap={3}
          columnGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: "repeat(1, 1fr)",
            sm: "repeat(3, 1fr)",
          }}
        >
          <RHFTextField name={"name"} label={"Product's name *"} />
          <RHFTextField name={"sku"} label={"Product's sku *"} />

          {/* TODO: main category */}
          <Autocomplete
            defaultValue={{
              label: data?.category?.parent?.name || "",
              id: data?.category?.parent?.id || "",
            }}
            name="category"
            disablePortal
            id="combo-box-main-category"
            options={
              mainCategories?.map((category) => ({
                label: category?.name,
                id: category?.id,
              })) || []
            }
            renderInput={(params) => (
              <RHFTextField
                name={"category"}
                {...params}
                label="Main Category *"
              />
            )}
            onChange={(event, newValues) =>
              methods.setValue("category", newValues ? newValues.id : null)
            }
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.label}
              </li>
            )}
          />

          {/* TODO: sub category */}
          <Autocomplete
            disabled={!selectedMainCategory}
            defaultValue={{
              label: data?.category?.name || "",
              id: data?.category?.id || "",
            }}
            name="sub_category"
            disablePortal
            id="combo-box-sub-category"
            options={
              filteredSubCategoryData?.map((category) => ({
                label: category?.label,
                id: category?.value,
              })) || []
            }
            renderInput={(params) => (
              <RHFTextField
                name={"sub_category"}
                {...params}
                label="Search sub category *"
              />
            )}
            onChange={(event, newValues) =>
              methods.setValue("sub_category", newValues ? newValues.id : null)
            }
            renderOption={(props, option) => (
              <li {...props} key={option.id}>
                {option.label}
              </li>
            )}
          />

          <RHFTextField
            disabled={
              !(
                variants.slice(-1)[0].selling_price === "" ||
                variants.slice(-1)[0].stock === "" ||
                variants.slice(-1)[0].stock === 0 ||
                variants.slice(-1)[0].price === ""
              )
            }
            name={"stock"}
            type="number"
            label={"Stock (If no variations*)"}
          />

          <RHFTextField
            disabled={
              !(
                variants.slice(-1)[0].selling_price === "" ||
                variants.slice(-1)[0].stock === "" ||
                variants.slice(-1)[0].stock === 0 ||
                variants.slice(-1)[0].price === ""
              )
            }
            name={"price"}
            type="number"
            label={"Price (If no variations*)"}
          />

          <RHFTextField
            disabled={
              !(
                variants.slice(-1)[0].selling_price === "" ||
                variants.slice(-1)[0].stock === "" ||
                variants.slice(-1)[0].stock === 0 ||
                variants.slice(-1)[0].price === ""
              )
            }
            name={"selling_price"}
            type="number"
            label={"Selling Price (If no variations*)"}
          />
        </Box>

        <Stack mt={3}>
          <Divider />

          <span className="my-3">Stasuses</span>

          <Box
            rowGap={3}
            columnGap={2}
            display="grid"
            gridTemplateColumns={{
              xs: "repeat(2, 1fr)",
              sm: "repeat(4, 1fr)",
            }}
          >
            <div className="border-2 w-fit p-2 rounded-xl">
              <RHFSwitch
                name={"is_featured"}
                label={<span>Is this is_featured product?</span>}
                labelPlacement="start"
              />
            </div>

            <div className="border-2 w-fit p-2 rounded-xl">
              <RHFSwitch
                name={"is_trending"}
                label={<span>Is this is_trending product?</span>}
                labelPlacement="start"
              />
            </div>

            <div className="border-2 w-fit p-2 rounded-xl">
              <RHFSwitch
                name={"is_new"}
                label={<span>Is this new product?</span>}
                labelPlacement="start"
              />
            </div>

            <div className="border-2 w-fit p-2 rounded-xl">
              <RHFSwitch
                name={"is_weekly_deals"}
                label={<span>Is this weekly deal?</span>}
                labelPlacement="start"
              />
            </div>
          </Box>
        </Stack>

        <Stack mt={3}>
          <Divider />

          <span className="my-3">Write description *</span>
          <RHFEditor
            placeholder="Write description here..."
            name={"description"}
          />
        </Stack>

        <Stack mt={3}>
          <Divider />
          <span className="my-3">Variations</span>
          <Stack gap={3} mt={3}>
            {variants?.map((size, index) => {
              return (
                <Stack
                  key={index}
                  flexDirection={"row"}
                  alignItems={"center"}
                  gap={5}
                >
                  <Stack
                    flexDirection={"row"}
                    alignItems={"center"}
                    width={"100%"}
                  >
                    <div className="flex-1">
                      <RHFTextField
                        value={size?.size}
                        // key={row?.variations?.[index]?.size}
                        defaultValue={data?.variations?.[index]?.size}
                        fullWidth
                        onChange={(event) => {
                          setVairants((prev) => {
                            return prev?.map((field, i) => {
                              if (i === index) {
                                return {
                                  ...field,
                                  size: event.target.value,
                                };
                              } else {
                                return field;
                              }
                            });
                          });
                        }}
                        type="text"
                        name="size"
                        label="Size"
                      />
                    </div>
                    <Divider style={{ width: "3%" }} />

                    <div className="flex-1">
                      <RHFTextField
                        value={size?.color}
                        // key={row?.variations?.[index]?.color}
                        defaultValue={data?.variations?.[index]?.color}
                        fullWidth
                        onChange={(event) => {
                          setVairants((prev) => {
                            return prev?.map((field, i) => {
                              if (i === index) {
                                return {
                                  ...field,
                                  color: event.target.value,
                                };
                              } else {
                                return field;
                              }
                            });
                          });
                        }}
                        type="text"
                        name="color"
                        label="Color"
                      />
                    </div>
                    <Divider style={{ width: "3%" }} />

                    <div className="flex-1">
                      <RHFTextField
                        value={size?.brand}
                        // key={row?.variations?.[index]?.brand}
                        defaultValue={data?.variations?.[index]?.brand}
                        fullWidth
                        onChange={(event) => {
                          setVairants((prev) => {
                            return prev?.map((field, i) => {
                              if (i === index) {
                                return {
                                  ...field,
                                  brand: event.target.value,
                                };
                              } else {
                                return field;
                              }
                            });
                          });
                        }}
                        type="text"
                        name="brand"
                        label="Brand"
                      />
                    </div>
                    <Divider style={{ width: "3%" }} />

                    <div className="flex-1">
                      <RHFTextField
                        value={size?.litre}
                        // key={row?.variations?.[index]?.litre}
                        defaultValue={data?.variations?.[index]?.litre}
                        fullWidth
                        onChange={(event) => {
                          setVairants((prev) => {
                            return prev?.map((field, i) => {
                              if (i === index) {
                                return {
                                  ...field,
                                  litre: event.target.value,
                                };
                              } else {
                                return field;
                              }
                            });
                          });
                        }}
                        type="text"
                        name="litre"
                        label="Litre"
                      />
                    </div>
                    <Divider style={{ width: "3%" }} />

                    <div className="flex-1">
                      <RHFTextField
                        value={size?.price}
                        // key={row?.variations?.[index]?.price}
                        defaultValue={data?.variations?.[index]?.price}
                        fullWidth
                        onChange={(event) => {
                          setVairants((prev) => {
                            return prev?.map((field, i) => {
                              if (i === index) {
                                return {
                                  ...field,
                                  price: event.target.value,
                                };
                              } else {
                                return field;
                              }
                            });
                          });
                        }}
                        type="number"
                        name="price"
                        label="Actual Price *"
                      />
                    </div>

                    <Divider style={{ width: "3%" }} />

                    <div className="flex-1">
                      <RHFTextField
                        value={size?.selling_price}
                        key={data?.variations?.[index]?.selling_price}
                        defaultValue={data?.variations?.[index]?.selling_price}
                        fullWidth
                        onChange={(event) => {
                          setVairants((prev) => {
                            return prev?.map((field, i) => {
                              if (i === index) {
                                return {
                                  ...field,
                                  selling_price: event.target.value,
                                };
                              } else {
                                return field;
                              }
                            });
                          });
                        }}
                        type="number"
                        name="selling_price"
                        label="After Offer *"
                      />
                    </div>

                    <Divider style={{ width: "3%" }} />

                    <div className="flex-1">
                      <RHFTextField
                        value={size?.stock}
                        key={data?.variations?.[index]?.stock}
                        defaultValue={data?.variations?.[index]?.stock}
                        fullWidth
                        onChange={(event) => {
                          setVairants((prev) => {
                            return prev?.map((field, i) => {
                              if (i === index) {
                                return {
                                  ...field,
                                  stock: event.target.value,
                                };
                              } else {
                                return field;
                              }
                            });
                          });
                        }}
                        type="number"
                        name="stock"
                        label="Stock *"
                      />
                    </div>
                  </Stack>

                  <Stack direction={"row"} alignItems={"center"} gap={2}>
                    <Button
                      onClick={() => handleRemoveFields(index)}
                      disabled={variants?.length === 1}
                    >
                      <Iconify icon="streamline:subtract-1-solid" />
                    </Button>

                    <Button
                      onClick={handleAddFields}
                      disabled={
                        // variants.slice(-1)[0].size === "" ||
                        // variants.slice(-1)[0].color === "" ||
                        variants.slice(-1)[0].selling_price === "" ||
                        variants.slice(-1)[0].stock === "" ||
                        variants.slice(-1)[0].stock === 0 ||
                        variants.slice(-1)[0].price === ""
                      }
                    >
                      <Iconify icon="teenyicons:add-solid" />
                    </Button>
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
        </Stack>

        <Box mt={3}>
          <Stack flexDirection={"row"} gap={3}>
            <Upload
              maxSize={1}
              // onRemove={(file) =>
              //   setDocuments((prev) => prev.filter((f) => f.key !== file.key))
              // }
              onRemove={(file) => {
                if (typeof file === "string") {
                  dispatch(
                    deleteProductImage({
                      slug: data?.gallery?.find((g) => g?.url === file)?.id,
                      img_name:
                        file?.split("/")?.[file?.split("/")?.length - 1],
                      enqueueSnackbar,
                      id: file,
                      setGalleries,
                      product_id: data?.id,
                      galleries,
                    })
                  );
                } else {
                  setDocuments((prev) =>
                    prev.filter((f) => f.key !== file.key)
                  );
                }
              }}
              thumbnail={true}
              files={
                documents?.length ? [...galleries, ...documents] : galleries
              }
              multiple={true}
              text="Drop or Select Photos"
              name="gallery"
              onDrop={handleDropGallery}
            />
          </Stack>
        </Box>

        <Stack mt={2} alignItems={"end"}>
          <LoadingButton
            loading={createProductLoading}
            disabled={createProductLoading}
            type="submit"
            variant="contained"
            className="!bg-primary w-fit"
          >
            {isEdit ? "Update Product" : "Create Product"}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Box>
  );
};

export default Form;
